import React, { useState } from 'react'
import { TextField, Button } from '@mui/material'
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import whatsappService from '../services/whatsappService';
import { useDispatch } from 'react-redux';
import { loginSuccessAction } from '../redux/actions/authActions';

export const WhatsappLoginVerify = () => {
    const [searchParams] = useSearchParams();
    const phone = searchParams.get('phone');
    const [code, setCode] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await whatsappService.verify(phone, code);
            console.log(data);
            toast.success(`Вы успешно вошли в систему`, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });

            // Store in Redux
            dispatch(loginSuccessAction(data));

            setTimeout(() => {
                navigate('/tourpackages');
            }, 1000);
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }

    }


    return (
        <form onSubmit={handleSubmit} className='flex flex-col gap-4 w-full max-w-md mx-auto mt-10 p-4 border rounded-md h-[500px]'>
            <TextField label="Введите код который вы получили на ватсап номер" value={code} onChange={(e) => setCode(e.target.value)} />
            <Button variant="contained" color="primary" type='submit'>Войти</Button>
        </form>
    )
}
